module.exports = __webpack_public_path__ + "img/item-C.b4d6511b.png";